(function () {

    'use strict';

    var P45RequestCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        console.log('P45RequestCtrl init!');
        if (!angular.isDefined(passedModel)) {
            passedModel = {};
        }
        $scope.ngModel = passedModel;

        $scope.ok = function () {
            $uibModalInstance.close(this.ngModel);
        };

        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirmP45Request = function ($event) {
            $event.preventDefault();
            if ($scope.ngModel.terminationDateFormatted != null && $scope.ngModel.terminationDateFormatted != "") {
                var externalId = $scope.ngModel.externalId;
                if(!externalId){
                    externalId = $("#executedBy").val();
                }
                
                var data = "terminationDate=" + $scope.ngModel.terminationDateFormatted + "&executedBy=" + $("#executedBy").val()+"&externalId="+ externalId;
                var ajaxUrl = WEBAPP_PATH + "/candidate/" + $scope.ngModel.submitAction + "/" + $("#candidateId").val();
                ajaxCall.getData(ajaxUrl, data).then(function(result) {
                    if (result.data.success == true) {
                        $scope.ngModel.smartTableRefreshCounter++;
                        xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                        $uibModalInstance.close($scope.ngModel);
                    }
                }, function(result) {
                    xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                    $scope.cancel();
                    console.log("Error in P45RequestCtrl.js", result);
                });
            }

            return false;
        };

    };
    P45RequestCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('P45RequestCtrl', P45RequestCtrl);

}());